<template>
    <flat-pickr ref="datePicker" v-if="dateConfig" v-model="selectedDate" class="date-picker" :config="dateConfig" :class="{ 'is-invalid': !state && state != null }" @input="dateUpdated"></flat-pickr>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css';
    import { Danish } from "flatpickr/dist/l10n/da.js";

    export default {
        components: { flatPickr },
        props: {
            value: {
                type: Array,
                default: () => []
            },
            state: null
        },
        data: () => ({
            selectedDate: [],
            dateConfig: null,
            isSyncing: false
        }),
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    var next = Array.isArray(val) ? [...val] : []
                    if (!this.areArraysEqual(next, this.selectedDate)) {
                        this.isSyncing = true
                        this.selectedDate = next
                        this.$nextTick(() => {
                            this.isSyncing = false
                        })
                    }
                }
            }
        },
        created() {
            this.dateConfig = {
                mode: "range",
                altFormat: 'j. M, Y',
                altInput: true,
                dateFormat: 'Y-m-d',
                locale: Danish,
                weekNumbers: true,
                enableTime: false,
                onChange(val) {

                }
            }
        },
        mounted() { },
        methods: {
            areArraysEqual(a, b) {
                if (a === b) {
                    return true
                }

                if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
                    return false
                }

                for (var i = 0; i < a.length; i++) {
                    if (a[i] !== b[i]) {
                        return false
                    }
                }

                return true
            },
            dateUpdated(val) {
                if (this.isSyncing) {
                    return
                }

                var fp = this.$refs.datePicker.fp

                var dates = []
                fp.selectedDates.forEach(x => {
                    dates.push(fp.formatDate(x, "Y-m-d"))
                })

                if (dates.length != 1) {
                    if (!this.areArraysEqual(dates, this.value)) {
                        this.$emit('input', dates)
                    }
                }

            }
        },
    }
</script>

<style lang="scss">
    .date-picker {
        &[readonly] {
            background-color: #ffffff !important;
        }

        &.is-invalid + input.form-control {
            border-color: #ea5455;
        }
    }
</style>